module.exports = __webpack_public_path__ + "static/ypourgeio-ependyseis-97e79aec4810674dd4ac05bc6a66e188.jpg";